import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as idcFunctions from '../../idc-functions'

export const RESOURCE = {
  payload: {
    description:
      'A broader classification of indirect costs used in indirect cost rate proposal.',
    dimension: idcFunctions.RESOURCE.payload,
    level: 1,
    name: 'IDC Subcategory',
    partialId: PartialId.Standard.create('subcat'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
